import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-7a2b0ba4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "mainInfoCard"
}
const _hoisted_2 = { class: "heading" }
const _hoisted_3 = {
  key: 3,
  class: "allRoutes"
}
const _hoisted_4 = { class: "heading" }
const _hoisted_5 = {
  key: 4,
  class: "routelink"
}
const _hoisted_6 = { class: "ctaLink rte" }

import {
  DownloadApp,
} from '@components';
import {
  computed,
  ref,
  watch,
  watchEffect,
} from 'vue';
import { useI18n } from 'vue-i18n';
import { Route } from '../../apiTypes';
import {
  ServiceStatusSearch,
  InfoCard,
  Icon,
  StatusKeyButton,
  RouteItemsList,
  mapRoutes,
} from '../../index';
import { useServiceStatusStore } from '../../stores';
import { RouteServiceStatus } from '../../types';
import { INFO_CARD_COLOR } from '../../../../constants/info-card-color';
import { smsAlertSignupUrl, mobileAppDownloadUrl } from '../../envVariables';
import { orderRoutesByOriginPortAsc } from '../../helpers/sortRoutesByOriginPort';


export default /*#__PURE__*/_defineComponent({
  __name: 'ServiceStatusHome',
  props: {
    isOverlayView: { type: Boolean },
    isMobile: { type: Boolean },
    statusModalClickHandler: { type: Function },
    selectRouteMapCallback: { type: Function },
    updateRouteMapCallback: { type: Function },
    redirectToServiceIndex: { type: Function },
    searchInputId: {},
    searchInputLabel: {},
    isOffline: { type: Boolean }
  },
  emits: ['getSelectedRouteCode', 'getHasSearch'],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();
const props = __props;

const emit = __emit;

const serviceStatusStore = useServiceStatusStore();
const renderAllRoutes = ref<RouteServiceStatus[]>();
const showAllRoutesList = ref(!!renderAllRoutes.value);
const affectedRoutes = ref<RouteServiceStatus[]>();
const showAffectedRoutesList = ref(!!affectedRoutes.value);
const hasSearchResults = ref(false);
const searchResults = ref<RouteServiceStatus[]>();
const isLoading = ref<boolean>(false);

const canShowRoutes = computed(() => (
  !hasSearchResults.value && !props.isOffline && !serviceStatusStore.isServiceStatusError
));

const displayAffectedRoutes = computed(() => (
  (showAffectedRoutesList.value || isLoading.value) && canShowRoutes.value
));

const displayAllRoutes = computed(() => (
  (showAllRoutesList.value || isLoading.value) && !props.isOverlayView && canShowRoutes.value
));

const updateMap = (results) => {
  if (props.updateRouteMapCallback) props.updateRouteMapCallback(results);
};

const searchClickAction = (searchValue) => {
  serviceStatusStore.addRecentSearch(searchValue, props.isMobile);
};

const updateSearchResults = (newSearchResults) => {
  hasSearchResults.value = newSearchResults !== undefined;
  searchResults.value = newSearchResults;
};

const mapRenderRoutes = (allRoutes: Route[] | undefined) => {
  renderAllRoutes.value = allRoutes ? allRoutes.map(mapRoutes)?.sort(orderRoutesByOriginPortAsc)
    : undefined;

  showAllRoutesList.value = !!(renderAllRoutes.value && renderAllRoutes
    .value
    .length > 0);

  affectedRoutes.value = serviceStatusStore.getAffectedRoutes
    ?.map(mapRoutes)?.sort(orderRoutesByOriginPortAsc);

  showAffectedRoutesList.value = !!(affectedRoutes.value && affectedRoutes
    .value
    .length > 0);
};

const itemClickAction = async (serviceArray, index) => {
  const { routeCode } = serviceArray[index];
  emit('getSelectedRouteCode', routeCode);
};

const getInfoCardDetails = () => {
  let noOfAffectedRoutes;
  let totalRoutes;

  if (serviceStatusStore.isServiceStatusError || serviceStatusStore.isRoutesSuggestionError) {
    return {
      icon: 'warning',
      text: t('Trouble retrieving service'),
      backgroundColor: INFO_CARD_COLOR.white,
      borderColor: INFO_CARD_COLOR.red,
    };
  }

  if (hasSearchResults.value) {
    const filteredAffectedResultsList = searchResults.value?.filter((item) => item.status !== 'normal');
    noOfAffectedRoutes = filteredAffectedResultsList?.length;
    totalRoutes = searchResults.value?.length;
  } else {
    noOfAffectedRoutes = affectedRoutes.value?.length;
    totalRoutes = renderAllRoutes.value?.length;
  }

  return (noOfAffectedRoutes > 0
    ? {
      icon: 'warning',
      text: t(
        'Number of routes affected text',
        [noOfAffectedRoutes, totalRoutes],
      ),
      backgroundColor: INFO_CARD_COLOR.white,
      borderColor: INFO_CARD_COLOR.red,
    }
    : {
      icon: 'statusNormal',
      text: t('All sailings normal text'),
      backgroundColor: INFO_CARD_COLOR.mint,
      borderColor: INFO_CARD_COLOR.mint,
    });
};

mapRenderRoutes(serviceStatusStore.serviceStatus);

watchEffect(() => {
  isLoading.value = serviceStatusStore.isLoading;
});

watch(() => serviceStatusStore.serviceStatus, (newVal) => {
  mapRenderRoutes(newVal);
});

watch(() => hasSearchResults.value, (newHasSearch) => {
  emit('getHasSearch', newHasSearch);
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(ServiceStatusSearch), {
      "item-click-action": (array, index) => itemClickAction(array, index),
      "select-route-map-callback": _ctx.selectRouteMapCallback,
      "search-click-action": searchClickAction,
      "search-input-id": _ctx.searchInputId,
      "search-input-label": _ctx.searchInputLabel,
      disabled: _ctx.isOffline,
      "is-loading": isLoading.value,
      onUpdateSearchResults: _cache[0] || (_cache[0] = (searchResults) => updateSearchResults(searchResults)),
      onUpdateMapRoute: _cache[1] || (_cache[1] = (searchResults) => updateMap(searchResults))
    }, {
      infoCard: _withCtx(() => [
        (!_ctx.isOffline)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_unref(InfoCard), {
                "icon-name": getInfoCardDetails().icon,
                text: getInfoCardDetails().text,
                "background-color": getInfoCardDetails().backgroundColor,
                "border-color": getInfoCardDetails().borderColor,
                "is-loading": isLoading.value,
                lg: ""
              }, null, 8, ["icon-name", "text", "background-color", "border-color", "is-loading"])
            ]))
          : _createCommentVNode("", true)
      ]),
      statusKeyButton: _withCtx(() => [
        (hasSearchResults.value && !_ctx.isOffline)
          ? (_openBlock(), _createBlock(_unref(StatusKeyButton), {
              key: 0,
              "on-click": _ctx.statusModalClickHandler
            }, null, 8, ["on-click"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["item-click-action", "select-route-map-callback", "search-input-id", "search-input-label", "disabled", "is-loading"]),
    (!hasSearchResults.value)
      ? _renderSlot(_ctx.$slots, "myRoutes", { key: 0 })
      : _createCommentVNode("", true),
    (!_ctx.isMobile)
      ? (_openBlock(), _createBlock(_unref(DownloadApp), {
          key: 1,
          "alert-link": _unref(smsAlertSignupUrl),
          "alert-link-text": _ctx.$t('Download App alert link text'),
          "download-link": _unref(mobileAppDownloadUrl),
          "download-link-text": _ctx.$t('Download App link text'),
          "image-src": require('@images/downloadAppImage.png'),
          "image-alt": _ctx.$t('Download app image alt'),
          title: _ctx.$t('Download App title'),
          text: _ctx.$t('Download App text'),
          class: "showMobile"
        }, null, 8, ["alert-link", "alert-link-text", "download-link", "download-link-text", "image-src", "image-alt", "title", "text"]))
      : _createCommentVNode("", true),
    (displayAffectedRoutes.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass(["affectedRoutes", {noBorder: _ctx.isOverlayView}])
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t('Affected routes')), 1),
            (!_ctx.isOverlayView)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "closeBtn",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (showAffectedRoutesList.value = false))
                }, [
                  _createTextVNode(_toDisplayString(_ctx.$t('Close')) + " ", 1),
                  _createVNode(_unref(Icon), {
                    "icon-name": "closeBold",
                    sm: ""
                  })
                ]))
              : _createCommentVNode("", true),
            (_ctx.isOverlayView)
              ? (_openBlock(), _createBlock(_unref(StatusKeyButton), {
                  key: 1,
                  "on-click": _ctx.statusModalClickHandler,
                  class: _normalizeClass({overlayView: _ctx.isOverlayView})
                }, null, 8, ["on-click", "class"]))
              : _createCommentVNode("", true)
          ]),
          (affectedRoutes.value)
            ? (_openBlock(), _createBlock(_unref(RouteItemsList), {
                key: 0,
                "route-items": affectedRoutes.value,
                "is-loading": isLoading.value,
                onGetRouteItemsIndex: _cache[3] || (_cache[3] = (routeItems, index) => itemClickAction(routeItems, index))
              }, null, 8, ["route-items", "is-loading"]))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    (displayAllRoutes.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t('All routes')), 1),
            _createVNode(_unref(StatusKeyButton), {
              "on-click": _ctx.statusModalClickHandler,
              class: _normalizeClass({overlayView: _ctx.isOverlayView})
            }, null, 8, ["on-click", "class"])
          ]),
          _createVNode(_unref(RouteItemsList), {
            "route-items": renderAllRoutes.value,
            "is-loading": isLoading.value,
            onGetRouteItemsIndex: _cache[4] || (_cache[4] = (routeItems, index) => itemClickAction(routeItems, index))
          }, null, 8, ["route-items", "is-loading"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isOverlayView)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("p", _hoisted_6, [
            _createElementVNode("a", {
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.redirectToServiceIndex && _ctx.redirectToServiceIndex(...args)))
            }, _toDisplayString(_ctx.$t('View all routes')), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})